module.exports = __webpack_public_path__ + "static/media/plus.2a5c2eb3.svg";